module.exports = __webpack_public_path__ + "img/laptop-bug.5a05d142.svg";